/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';

const PublicRoute = ({ children, redirect }) => {
    const { isAuthenticated } = useSelector(state => state.auth);

    // if (isAuthenticated && redirect) {
    //     return <Navigate to="/profile" />;
    // }

    return children;
};

export default PublicRoute;
